<template>
  <div>
    <!-- <Nav :isFixed="bannerFixed"></Nav> -->
    <TermsCom class="pc-doc container"></TermsCom>
    <Bottom></Bottom>
    <Float />
  </div>
</template>
<script>
// import Nav from '../components/pc/nav.vue'
import TermsCom from '../components/termsCom.vue'
import Bottom from '../components/pc/bottom.vue'
import Float from '../components/pc/home/float.vue'

export default {
  data() {
    return {
      bannerFixed: false,
    }
  },
  components: {
    // Nav,
    TermsCom,
    Bottom,
    Float
  },
  mounted() {
    this.handleScroll()
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      if (window.scrollY > 80) {
        this.bannerFixed = true
      } else {
        this.bannerFixed = false
      }
    },
  },
}
</script>
<style lang="scss">
@import '@/styles/public';
.pc-doc {
  padding-bottom: 80px;
  .title {
    text-align: center;
    font-size: 32px;
    font-weight: bold;
    color: $theme-color;
    margin: 40px 0 30px;
  }
  .text {
    line-height: 1.5;
    color: #333;
    margin-bottom: 10px;
  }
  .bold {
    font-weight: bold;
  }
  .s-title {
    color: $theme-color;
    font-size: 24px;
    margin: 30px 0 10px;
    font-weight: bold;
  }
}
</style>
